import { render, staticRenderFns } from "./GamePhoto.vue?vue&type=template&id=7216fe45"
import script from "./GamePhoto.vue?vue&type=script&lang=js"
export * from "./GamePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports